// extracted by mini-css-extract-plugin
export default {"workouts":"Workouts_workouts__-nng5","gridContainer":"Workouts_gridContainer__TYppY"};